<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>

          <div class="tile is-vertical is-12 internbackground">
            <AdminBase :usuario="admin" />
            <internfooter />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UserService from "@/services/UserService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import AdminBase from "@/components/Perfil/AdminBase";
import store from "@/store";

export default {
  data() {
    return {
      admin: {
        profile_picture: "",
        name: "",
        sobrenome: "",
        cpf: "",
        telefone: "",
        email: "",
        password: ""
      },
      user: store.getters.user
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    AdminBase: AdminBase
  },
  created() {
    UserService.Info(this.user).then(result => {
      this.admin = result.data;
    });
  }
};
</script>